import * as v from "valibot";
import { BaseRecordSchema, defineRecordSchema, defineValidation } from "../../common/validation.common";

export namespace AuditProductInternetValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const SelectRecord = defineValidation(
        defineRecordSchema({
            filters: v.object({
                audit: v.optional(v.boolean()),
                associateId: v.optional(v.string()),
            }),
        }),
    );
}
